import React from 'react'

function Etherscan() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="13"
            fill="none"
            viewBox="0 0 13 13"
        >
            <path
                fill="currentColor"
                d="M2.702 6.19a.55.55 0 01.553-.552l.918.003a.552.552 0 01.552.552v3.47c.103-.03.236-.063.38-.097a.46.46 0 00.355-.448V4.814a.552.552 0 01.552-.552h.92a.552.552 0 01.551.552v3.995s.23-.093.454-.188a.46.46 0 00.282-.424V3.435a.552.552 0 01.551-.552h.92a.552.552 0 01.551.552v3.921c.798-.577 1.606-1.272 2.247-2.108a.926.926 0 00.14-.864A6.487 6.487 0 006.583.003C2.978-.046 0 2.896 0 6.5a6.477 6.477 0 00.863 3.25.821.821 0 00.784.406c.173-.015.39-.037.647-.067a.46.46 0 00.408-.456V6.19M2.682 11.754a6.497 6.497 0 0010.301-5.7c-2.374 3.54-6.757 5.196-10.301 5.7"
            ></path>
        </svg>
    )
}

export default Etherscan
